import { useSearchParams } from "next/navigation"
import { type FunctionComponent, useEffect, useState } from "react"

import { Select } from "@jobteaser/spark/components/Select"

import { DEFAULT_RADIUS_KM, RADIUS_KM_OPTIONS } from "@/modules/jobAds/client/constants"
import { useJobAdsFilterNavigation } from "@/modules/jobAds/client/hooks/useJobAdsFilterNavigation"

import styles from "./RadiusFilter.module.css"

const options = RADIUS_KM_OPTIONS.map(value => {
  return {
    label: `+${value} km`,
    type: "option" as const,
    value: `${value}`,
  }
})

type RadiusFilterProps = {
  label: string
}

export const RadiusFilter: FunctionComponent<RadiusFilterProps> = ({ label }) => {
  const searchParams = useSearchParams()
  const radiusParam = searchParams.get("radius") || undefined
  const isRadiusParamValid = RADIUS_KM_OPTIONS.includes(Number(radiusParam))
  const defaultRadiusOption = options.find(
    option => option.value === `${isRadiusParamValid ? radiusParam : DEFAULT_RADIUS_KM}`
  )
  const { navigateWithUpdatedQueryParams } = useJobAdsFilterNavigation()
  const [radius, setRadius] = useState(defaultRadiusOption)

  const handleRadiusChange = (selectedRadius: string): void => {
    setRadius(options.find(option => option.value === selectedRadius))
    navigateWithUpdatedQueryParams({
      availableFilters: {
        radius: selectedRadius,
      },
    })
  }

  useEffect(() => {
    setRadius(defaultRadiusOption)
  }, [defaultRadiusOption])

  return (
    <div className={styles.main}>
      <Select
        aria-label={label}
        className={styles.select}
        defaultValue={radius?.value}
        fieldClassName={styles.selectField}
        id="radius-filter"
        name="radius-filter"
        onSelect={handleRadiusChange}
        options={options}
      />
    </div>
  )
}
